// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"a3a5ea94","739":"f5089aa9"}[chunkId] + ".chunk.js";
};